import React from "react";

import t from "../../lib/translate";

import formSentGraphic from "../../../static/assets/images/form-sent.svg";
import { Headline } from "../../components/Headline";
import * as styles from "./FormSent.module.less";

function FormSent() {
    // TODO: implement tag manager
    return (
        <>
            <img src={formSentGraphic} />

            <Headline semanticOfHeadline="H1">
                {t("form.sent.headline")}
            </Headline>
            <div className={styles.backButton}>{t("form.sent.text")}</div>
        </>
    );
}

export { FormSent };
